module.exports = __webpack_public_path__ + "media/images/emblems/Nods-coat_of_arms-4d8c9e08cd7b328d55f38025649abe6e.svg";